import { render, staticRenderFns } from "./LHNChat.vue?vue&type=template&id=52718650&scoped=true&lang=pug&"
import script from "./LHNChat.vue?vue&type=script&lang=ts&"
export * from "./LHNChat.vue?vue&type=script&lang=ts&"
import style0 from "./LHNChat.vue?vue&type=style&index=0&id=52718650&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52718650",
  null
  
)

export default component.exports